import { getMainImagesWebUrl } from "../constants/urls";
import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { InventoryActions, Reference } from "../../domain/inventory";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const getMainImagesWebService = {
    async execute(token: string): Promise<Reference[]> {
        const url = getEnvVariable
            .execute("VUE_APP_DACCACH_URL")
            .concat(getMainImagesWebUrl);

        const headers = {
            "web-token": token,
            Accept: "application/json",
        };

        const response: RestResponse = await restClient().sendRequest(
            url,
            "GET",
            null,
            headers
        );

        if (!response.isSuccess) {
            const errorMessage =
                response.statusCode == 422
                    ? DaccachErrorActions().extractFormError(response.content)
                    : response.content;
            throw DaccachErrorActions().createError(errorMessage);
        }

        return InventoryActions().deserialize(response.content);
    },
};
